import React from 'react'
import Textarea from '../../../../components/common/form/textarea/Textarea'
import { IStudentSurveyQuestionTypeProps } from '../StudentSurveyQuestion'
import './TextQuestion.less'

const TextQuestion = ({
  setAnswer,
  answer,
  question
}: IStudentSurveyQuestionTypeProps) => {
  return (
    <div className="TextQuestion">
      <Textarea
        // @ts-expect-error 9/11/2020
        value={answer || ''}
        id={`question-id-${question.id}`}
        onChange={(value) => {
          setAnswer(value ? value : null)
        }}
      />
    </div>
  )
}

export default TextQuestion
